<template>
  <div class="radius-bx">
    <span :style="`background-color:${eventColor}`">{{ rscName }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil } from 'lodash';

export default {
  name: 'WFlowMapProcessBox',
  props: {
    rscPerfData: {
      type: Object,
      default: () => {},
    },
    rscPerfKey: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['eventlevelInfo']),
    rscName() {
      if (!isNil(this.rscPerfData)) {
        return this.rscPerfData[`${this.rscPerfKey}/RSCNAME`];
      }
      return null;
    },
    eventColor() {
      const eventlevelId = this.rscPerfData[`${this.rscPerfKey}/EVENTLEVEL_ID`];
      const eventlevel = this.eventlevelInfo[eventlevelId];

      if (!isNil(eventlevel)) {
        return eventlevel.eventlevelColorBg;
      }
      return null;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/components/FlowMapProcessBox.vue